import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

const PageTransition = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Trigger page transition animation
    const pageElement = document.querySelector('.page-content');
    if (pageElement) {
      pageElement.classList.remove('page-enter');
      // Force reflow
      void pageElement.offsetWidth;
      pageElement.classList.add('page-enter');
    }
  }, [location.pathname]);

  return (
    <div className="page-content">
      {children}
    </div>
  );
};

export default PageTransition;

